// extracted by mini-css-extract-plugin
export var columnList = "_eu-0";